import { AxiosResponse } from "axios";

import API from "../api";
import { Contact } from "Models/contact";

const ROUTE_NAME = "contacts";

const ContactService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Contact[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(contact: any): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}`, contact);
  },
  async update(id: number, contact: any): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, contact);
  },
  async delete(id: number): Promise<AxiosResponse<any>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default ContactService;
